window.addEventListener('DOMContentLoaded', function () {
    const linksColumns = document.querySelectorAll(".make-model-links-column");
    const maxItemsInCollapsedState = 5;

    linksColumns.forEach((c) => {
        const listGroup = c.querySelector('.list-group');
        listGroup.style.gridAutoFlow = "column";
        
        const links = listGroup.querySelectorAll('a');

        if (!matchMedia("(min-width: 992px)").matches || links.length <= maxItemsInCollapsedState) {
            listGroup.style['grid-template-rows'] = 'repeat(' + links.length + ', max-content)';
            return;
        }

        listGroup.style['grid-template-rows'] = 'repeat(' + maxItemsInCollapsedState + ', max-content)';
        links.forEach((item, i) => {
            if (i >= maxItemsInCollapsedState) {
                item.style.display = 'none';
            }
        });

        const btn = document.createElement('div');
        btn.innerHTML = `<button class="mb-1 expand-col-btn"><i class="icon"></i>See all ${c.getAttribute("data-title")}</button>`
        c.appendChild(btn);

        c.querySelector(".expand-col-btn")?.addEventListener('click', (e) => {
            e.target.style.display = 'none';
            listGroup.style['grid-template-rows'] = 'repeat(' + links.length + ', max-content)';
            links.forEach((item) => item.style.display = 'block');
        })
    })
});